<template>
	<view class="review">
		<!-- 门店评价 -->
		<view class="review_appraise">
			<view class="review_appraise_top">
				<view class="label">门店评价</view>
				<uni-rate color="#bbb" active-color="red" v-model="rateValue" size="18" @change="onChange" />
				<text>非常好</text>
			</view>
			<view class="review_appraise_bottom">
				<textarea placeholder="描述商品和使用感受，更受欢迎哦～">
				</textarea>
				<view class="review_appraise_bottom_list">
					<view class="review_appraise_bottom_list_item">
						<image src="@/static/icon/ic_upload@2x.png" mode="widthFix"></image>
					</view>
				</view>
			</view>
		</view>
		<!-- 物流服务评价 -->
		<view class="review_wuliu">
			<view class="review_wuliu_head">
				<text>物流服务评价</text>
				<text>满意请给5星哦</text>
			</view>
			<view class="review_wuliu_item">
				<view class="label">店内环境</view>
				<uni-rate color="#bbb" active-color="red" v-model="rateValue" size="18" @change="onChange" />
				<text>非常好</text>
			</view>
			<view class="review_wuliu_item">
				<view class="label">店内环境</view>
				<uni-rate color="#bbb" active-color="red" v-model="rateValue" size="18" @change="onChange" />
				<text>非常好</text>
			</view>
		</view>
		<!-- 推荐菜 -->
		<view class="review_recommend">
			<view class="title">推荐菜</view>
			<view class="list">
				<view class="list_item" v-for="(item, index) in 5" :key="index">水泥拿铁</view>
			</view>
		</view>
		<!-- 提交评价 -->
		<view class="review_submit">
			<view class="review_submit_btn">提交评价</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				rateValue: 5
			}
		},
		methods: {
			onChange(e) {
				this.rateValue = e.value
			}
		}
	}
</script>

<style lang="scss" scoped>
	.review {
		width: 100%;
		.review_appraise {
			padding: 32rpx;
			background-color: #ffffff;
			.review_appraise_top {
				display: flex;
				align-items: center;
				.label {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
					margin-right: 18rpx;
				}
				text {
					font-size: 24rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #CCCCCC;
					margin-left: 24rpx;
				}
			}
			.review_appraise_bottom {
				width: 100%;
				background: #F5F5F5;
				border-radius: 12rpx;
				margin-top: 28rpx;
				padding: 30rpx 24rpx;
				box-sizing: border-box;
				textarea {
					width: 100%;
					height: 100rpx;
				}
				.review_appraise_bottom_list {
					margin-top: 50rpx;
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					.review_appraise_bottom_list_item {
						width: 172rpx;
						height: 172rpx;
						margin-right: 30rpx;
						image {
							width: 100%;
							height: 100%;
						}
					}
				}
			}
		}
		.review_wuliu {
			margin-top: 16rpx;
			padding: 28rpx 32rpx;
			background-color: #ffffff;
			box-sizing: border-box;
			.review_wuliu_head {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 58rpx;
				text {
					&:first-child {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					&:last-child {
						font-size: 24rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #999999;
					}
				}
			}
			.review_wuliu_item {
				display: flex;
				align-items: center;
				margin-bottom: 34rpx;
				&:last-child {
					margin-bottom: 0 !important;
				}
				.label {
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #333333;
					margin-right: 30rpx;
				}
				text {
					font-size: 24rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #CCCCCC;
					margin-left: 24rpx;
				}
			}
		}
		.review_recommend {
			padding: 24rpx 32rpx;
			background-color: #ffffff;
			margin-top: 16rpx;
			.title {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.list {
				margin-top: 28rpx;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				.list_item {
					padding: 10rpx 28rpx;
					background: #F5F5F5;
					border-radius: 24rpx;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
					margin-left: 16rpx;
					margin-bottom: 20rpx;
					&:first-child {
						margin-left: 0 !important;
					}
				}
			}
		}
		.review_submit {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 60rpx;
			.review_submit_btn {
				width: 638rpx;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
			}
		}
	}
</style>